import * as i0 from '@angular/core';
import { Directive, Input, Injectable, EventEmitter, ViewContainerRef, ViewChild, Output, Component, NgModule } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

class StructuredDataBaseComponent {
    constructor() {
        this.InstanceId = "";
    }
}
StructuredDataBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive });
StructuredDataBaseComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: StructuredDataBaseComponent, inputs: { InstanceId: ["instance-id", "InstanceId"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataBaseComponent, decorators: [{
            type: Directive
        }], propDecorators: { InstanceId: [{
                type: Input,
                args: ['instance-id']
            }] } });

var ValueType;
(function (ValueType) {
    ValueType[ValueType["Currency"] = 1] = "Currency";
    ValueType[ValueType["Distance"] = 2] = "Distance";
    ValueType[ValueType["Area"] = 3] = "Area";
    ValueType[ValueType["TimeInterval"] = 5] = "TimeInterval";
    ValueType[ValueType["Weight"] = 6] = "Weight";
    ValueType[ValueType["YesNo"] = 7] = "YesNo";
    ValueType[ValueType["Percent"] = 8] = "Percent";
    ValueType[ValueType["Text"] = 10] = "Text";
    ValueType[ValueType["Volume"] = 12] = "Volume";
    ValueType[ValueType["Number"] = 13] = "Number";
    ValueType[ValueType["Date"] = 14] = "Date";
    ValueType[ValueType["LegalEntity"] = 15] = "LegalEntity";
    ValueType[ValueType["Commodity"] = 16] = "Commodity";
    ValueType[ValueType["OptionList"] = 17] = "OptionList";
    ValueType[ValueType["User"] = 18] = "User";
})(ValueType || (ValueType = {}));
var YesNo;
(function (YesNo) {
    YesNo[YesNo["Yes"] = 1] = "Yes";
    YesNo[YesNo["No"] = 2] = "No";
})(YesNo || (YesNo = {}));

class StructuredDataHelper {
    static newId() {
        let guidString = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        return guidString.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    static nullId() {
        return '00000000-0000-0000-0000-000000000000';
    }
    static GetEmptyUnitValueModel(decPlaces) {
        return {
            Unit: "",
            UnitId: StructuredDataHelper.nullId(),
            UnitDecimalPlaces: decPlaces,
            Value: null
        };
    }
    static GetEmptyTextValueCell() {
        return null;
    }
    static GetEmptyValueModel() {
        return {
            Id: StructuredDataHelper.nullId(),
            Value: null
        };
    }
    static GetNullEntryFromNode(node) {
        let rootEntry = {
            Id: this.newId(),
            ChildEntries: [],
            IsRoot: true,
            StructuredDataNodeId: node.Id,
            Value: null,
            ValueType: null
        };
        for (let childNodeCount = 0; childNodeCount < node.ChildNodes.length; childNodeCount++) {
            let childEntry = {
                Id: StructuredDataHelper.newId(),
                IsRoot: false,
                ChildEntries: [],
                StructuredDataNodeId: node.ChildNodes[childNodeCount].Id,
                ValueType: node.ChildNodes[childNodeCount].ValueOption.ValueType,
                Value: null
            };
            if (StructuredDataHelper.IsYesNoCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)
                || StructuredDataHelper.IsCommodityCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)
                || StructuredDataHelper.IsForeignKeyCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)
                || StructuredDataHelper.IsOptionListCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)) {
                childEntry.Value = StructuredDataHelper.GetEmptyValueModel();
            }
            else if (StructuredDataHelper.IsCurrencyCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)
                || StructuredDataHelper.IsUnitValueCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)) {
                childEntry.Value = StructuredDataHelper.GetEmptyUnitValueModel(2);
            }
            else if (StructuredDataHelper.IsDateCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)
                || StructuredDataHelper.IsNumberCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)
                || StructuredDataHelper.IsTextCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)
                || StructuredDataHelper.IsPercentageCell(node.ChildNodes[childNodeCount].ValueOption.ValueType)) {
                childEntry.Value = StructuredDataHelper.GetEmptyTextValueCell();
            }
            rootEntry.ChildEntries.push(childEntry);
        }
        return rootEntry;
    }
    static IsEntryValue(valueType) {
        switch (valueType) {
            case ValueType.Currency:
            case ValueType.Distance:
            case ValueType.Area:
            case ValueType.Volume:
            case ValueType.TimeInterval:
            case ValueType.Weight:
            case ValueType.Percent:
            case ValueType.Text:
            case ValueType.Number:
            case ValueType.Date:
                return false;
            case ValueType.YesNo:
            case ValueType.LegalEntity:
            case ValueType.Commodity:
            case ValueType.OptionList:
            case ValueType.User:
                return true;
            default:
                throw `Unknown Value Type: ${ValueType[valueType]}`;
        }
    }
    static IsUnitValue(valueType) {
        switch (valueType) {
            case ValueType.Currency:
            case ValueType.Distance:
            case ValueType.Area:
            case ValueType.Volume:
            case ValueType.TimeInterval:
            case ValueType.Weight:
                return true;
            case ValueType.YesNo:
            case ValueType.Percent:
            case ValueType.Text:
            case ValueType.Number:
            case ValueType.Date:
            case ValueType.LegalEntity:
            case ValueType.Commodity:
            case ValueType.OptionList:
            case ValueType.User:
                return false;
            default:
                throw `Unknown Value Type: ${ValueType[valueType]}`;
        }
    }
    static IsDateValue(valueType) {
        switch (valueType) {
            case ValueType.Date:
                return true;
            default:
                return false;
        }
    }
    static IsYesNoValue(valueType) {
        switch (valueType) {
            case ValueType.YesNo:
                return true;
            default:
                return false;
        }
    }
    static IsStringValue(valueType) {
        switch (valueType) {
            case ValueType.Percent:
            case ValueType.Text:
            case ValueType.Number:
            case ValueType.LegalEntity:
            case ValueType.Commodity:
            case ValueType.OptionList:
            case ValueType.User:
                return true;
            default:
                return false;
        }
    }
    static IsCurrencyCell(valueType) {
        return valueType === ValueType.Currency;
    }
    static IsCommodityCell(valueType) {
        return valueType === ValueType.Commodity;
    }
    static IsDateCell(valueType) {
        return valueType === ValueType.Date;
    }
    static IsForeignKeyCell(valueType) {
        return valueType === ValueType.User || valueType === ValueType.LegalEntity;
    }
    static IsNumberCell(valueType) {
        return valueType === ValueType.Number;
    }
    static IsOptionListCell(valueType) {
        return valueType === ValueType.OptionList;
    }
    static IsPercentageCell(valueType) {
        return valueType === ValueType.Percent;
    }
    static IsUnitValueCell(valueType) {
        return valueType === ValueType.Distance
            || valueType === ValueType.Area
            || valueType === ValueType.TimeInterval
            || valueType === ValueType.Weight
            || valueType === ValueType.Volume;
    }
    static IsYesNoCell(valueType) {
        return valueType === ValueType.YesNo;
    }
    static IsTextCell(valueType) {
        return valueType === ValueType.Text;
    }
    static getElementFromCell(cell, nodeName) {
        for (let childCount = 0; childCount < cell.childElementCount; childCount++) {
            let element = cell.children[childCount];
            if (element.nodeName === nodeName) {
                return element;
            }
        }
        throw `Could not find the element with nodename - ${nodeName} - in the cell`;
    }
    static GetInputElementFromCell(cell) {
        return StructuredDataHelper.getElementFromCell(cell, StructuredDataHelper.InputNodeName);
    }
    static GetSelectFromCell(cell) {
        return StructuredDataHelper.getElementFromCell(cell, StructuredDataHelper.SelectNodeName);
    }
    static DropDownSetValue(entry, elementRef) {
        var selectCell = StructuredDataHelper.GetSelectFromCell(elementRef.nativeElement);
        var valueModel = entry.Value;
        if (valueModel) {
            selectCell.value = valueModel.Id;
        }
    }
    static DropDownSetValueYesNo(entry, elementRef) {
        var selectCell = StructuredDataHelper.GetSelectFromCell(elementRef.nativeElement);
        selectCell.value = entry.Value;
    }
    static UnitSetValue(entry, elementRef) {
        var selectCell = StructuredDataHelper.GetSelectFromCell(elementRef.nativeElement);
        var valueModel = entry.Value;
        var inputElement = StructuredDataHelper.GetInputElementFromCell(elementRef.nativeElement);
        if (valueModel) {
            selectCell.value = valueModel.UnitId;
            if (valueModel.Value) {
                inputElement.value = valueModel.Value.toString();
            }
        }
    }
    static TextSetValue(entry, elementRef) {
        StructuredDataHelper.GetInputElementFromCell(elementRef.nativeElement).value = entry.Value;
    }
}
StructuredDataHelper.SelectNodeName = "SELECT";
StructuredDataHelper.InputNodeName = "INPUT";

class StructuredDataLibraryService {
    constructor() {
        this._displayMappers = [];
        this._lookupConfigurationModel = null;
        this._editOverrides = [];
        this._deleteOverride = [];
        this._addOverride = [];
        this._paginationOverride = [];
        this._hideLabelsForEmptyValues = [];
        this._defaultMapper = {
            ValueType: 0,
            Map: (value) => {
                if (!value) {
                    return null;
                }
                return value.Value;
            },
            IsHtml: false
        };
        this._defaultTextMapper = {
            ValueType: 0,
            Map: (value) => {
                return value;
            },
            IsHtml: false
        };
        this._unitDefaultMapper = {
            ValueType: 0,
            Map: (value) => {
                if (!value || !value.Value) {
                    return null;
                }
                return `${value.Value} ${value.Unit}`;
            },
            IsHtml: false
        };
        this._yesNoWrapper = {
            ValueType: 0,
            Map: (value) => {
                if (!value || value < 1 || value > 2) {
                    return null;
                }
                return YesNo[value];
            },
            IsHtml: false
        };
    }
    DiscardInstance(id) {
        let discardIndex = this._displayMappers.findIndex((kvp) => {
            return kvp.key === id;
        });
        if (discardIndex !== -1) {
            this._displayMappers.splice(discardIndex, 1);
        }
    }
    HideLabelsForEmptyValues(instanceId) {
        return this._hideLabelsForEmptyValues.find((hideLabelSettings) => {
            return hideLabelSettings.key === instanceId;
        }).value;
    }
    IsLookupConfigurationRegistered() {
        return this._lookupConfigurationModel ? true : false;
    }
    GetLookup(valueType) {
        switch (valueType) {
            case ValueType.Currency:
                return this._lookupConfigurationModel.Currency;
            case ValueType.Distance:
                return this._lookupConfigurationModel.Distance;
            case ValueType.Area:
                return this._lookupConfigurationModel.Area;
            case ValueType.TimeInterval:
                return this._lookupConfigurationModel.TimeInterval;
            case ValueType.Weight:
                return this._lookupConfigurationModel.Weight;
            case ValueType.YesNo:
                return this._lookupConfigurationModel.YesNo;
            case ValueType.OptionList:
                return this._lookupConfigurationModel.OptionList;
            case ValueType.Volume:
                return this._lookupConfigurationModel.Volume;
            case ValueType.Commodity:
                return this._lookupConfigurationModel.Commodity;
            case ValueType.User:
                return this._lookupConfigurationModel.User;
            default:
                return [];
        }
    }
    RegisterLookupConfiguration(lookupConfigurationModel) {
        this._lookupConfigurationModel = lookupConfigurationModel;
    }
    RegisterInstance(id, mappers, editOverrides, deleteOverride, addOverride, paginationOverride, hideLabelsForEmptyValues) {
        this._hideLabelsForEmptyValues.push({
            key: id,
            value: hideLabelsForEmptyValues
        });
        this._displayMappers.push({
            key: id,
            value: mappers
        });
        this._editOverrides.push({
            key: id,
            value: editOverrides
        });
        if (deleteOverride) {
            this._deleteOverride.push({
                key: id,
                value: deleteOverride
            });
        }
        if (addOverride) {
            this._addOverride.push({
                key: id,
                value: addOverride
            });
        }
        if (paginationOverride) {
            this._paginationOverride.push({
                key: id,
                value: paginationOverride
            });
        }
    }
    GetPaginationOverride(instanceId) {
        const instance = this._paginationOverride.find((paginationOverride) => {
            return paginationOverride.key === instanceId;
        });
        if (!instance) {
            return null;
        }
        return instance.value ? instance.value : null;
    }
    GetAddOverride(instanceId) {
        const instance = this._addOverride.find((addOverride) => {
            return addOverride.key === instanceId;
        });
        if (!instance) {
            return null;
        }
        return instance.value ? instance.value : null;
    }
    GetDeleteOverride(instanceId) {
        const instance = this._deleteOverride.find((deleteOverride) => {
            return deleteOverride.key === instanceId;
        });
        if (!instance) {
            return null;
        }
        return instance.value ? instance.value : null;
    }
    GetOverride(instanceId, valueType) {
        let structuredDataInstance = this._editOverrides.find((editOverride) => {
            return editOverride.key === instanceId;
        });
        if (structuredDataInstance) {
            let editMapper = structuredDataInstance.value.find((override) => {
                return override.ValueType === valueType;
            });
            return editMapper ? editMapper : null;
        }
        else {
            return null;
        }
    }
    GetMapper(instanceId, valueType) {
        let structuredDataInstance = this._displayMappers.find((kvp) => {
            return kvp.key === instanceId;
        });
        if (structuredDataInstance) {
            let displayMapper = structuredDataInstance.value.find((mapper) => {
                return mapper.ValueType === valueType;
            });
            if (displayMapper)
                return displayMapper;
            else
                return this.getMapperByValueType(valueType);
        }
        else {
            return this.getMapperByValueType(valueType);
        }
    }
    getMapperByValueType(valueType) {
        if (valueType === ValueType.YesNo) {
            return this._yesNoWrapper;
        }
        return StructuredDataHelper.IsUnitValue(valueType) ? this._unitDefaultMapper :
            StructuredDataHelper.IsEntryValue(valueType) ? this._defaultMapper : this._defaultTextMapper;
    }
}
StructuredDataLibraryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataLibraryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StructuredDataLibraryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataLibraryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataLibraryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class StructuredDataEditCellComponent extends StructuredDataBaseComponent {
    //TODO: Must Add Classes For TemplateRow | EditRow | ViewRow (And always value type per cell)
    //TODO: Set Cell Classes Based on Value Type
    //TODO: (Low priority)Add Ability for EditOverride to set cell class -> If Need be
    //TODO: Only surface edit event (And update corresponding entry) if the cell is valid
    //TODO: Expose validate event
    constructor(_structuredDataService) {
        super();
        this._structuredDataService = _structuredDataService;
        this._hasSurfacedRef = false;
        this._overrideRefReplay = new ReplaySubject(1);
        this.Entry = null;
        this.Node = null;
        this.EditOverride = null;
        this.Lookup = [];
        this.ChangeEvent = new EventEmitter();
    }
    set OverrideRef(viewRef) {
        if (!this._hasSurfacedRef) {
            this._hasSurfacedRef = true;
            this._overrideRefReplay.next(viewRef);
        }
    }
    ;
    ngOnInit() {
        this.setupOverride();
    }
    ngAfterViewInit() {
        if (!this.Overridden) {
            this.SetValue();
        }
    }
    setupOverride() {
        this.EditOverride = this._structuredDataService.GetOverride(this.InstanceId, this.Node.ValueOption.ValueType);
        if (this.EditOverride) {
            this._overrideRefReplay.subscribe((viewRef) => {
                this.EditOverride.Edit.next({
                    Entry: this.Entry,
                    Node: this.Node,
                    ViewReference: viewRef,
                    FireEdit: this.GetFireEditObservable()
                });
            });
        }
        else {
            this.Lookup = this._structuredDataService.GetLookup(this.Node.ValueOption.ValueType);
        }
    }
    get Overridden() {
        return !!this.EditOverride;
    }
}
StructuredDataEditCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataEditCellComponent, deps: [{ token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Directive });
StructuredDataEditCellComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: StructuredDataEditCellComponent, inputs: { Entry: ["entry", "Entry"], Node: ["data-node", "Node"] }, outputs: { ChangeEvent: "structured-entry-data-change" }, viewQueries: [{ propertyName: "OverrideRef", first: true, predicate: ["override"], descendants: true, read: ViewContainerRef }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataEditCellComponent, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }]; }, propDecorators: { OverrideRef: [{
                type: ViewChild,
                args: ['override', { read: ViewContainerRef }]
            }], Entry: [{
                type: Input,
                args: ['entry']
            }], Node: [{
                type: Input,
                args: ['data-node']
            }], ChangeEvent: [{
                type: Output,
                args: ['structured-entry-data-change']
            }] } });

class UnitValueCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService, _elementRef) {
        super(structuredDataService);
        this._elementRef = _elementRef;
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
        let sel = event.target;
        const entryValue = this.Entry.Value;
        if (entryValue) {
            this.Entry.Value.UnitId = sel.value;
            this.Entry.Value.Unit = sel.options[sel.selectedIndex].text;
        }
        else {
            this.Entry.Value = {
                Value: null,
                UnitId: sel.value,
                Unit: sel.options[sel.selectedIndex].text,
                UnitDecimalPlaces: 0
            };
        }
        this.ChangeEvent.emit(this.Entry);
    }
    ValueTextChange(event) {
        const entryValue = this.Entry.Value;
        if (entryValue) {
            this.Entry.Value.Value = Number.parseFloat(event.target.value);
        }
        else {
            this.Entry.Value = {
                Value: Number.parseFloat(event.target.value),
                UnitId: StructuredDataHelper.nullId,
                Unit: '',
                UnitDecimalPlaces: 0
            };
        }
        this.ChangeEvent.emit(this.Entry);
    }
    SetValue() {
        setTimeout(() => {
            StructuredDataHelper.UnitSetValue(this.Entry, this._elementRef);
        });
    }
}
UnitValueCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: UnitValueCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
UnitValueCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: UnitValueCellComponent, selector: "td[unit-value-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <input type=\"number\" (change)=\"ValueTextChange($event)\" />\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of Lookup\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: UnitValueCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[unit-value-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <input type=\"number\" (change)=\"ValueTextChange($event)\" />\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of Lookup\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; } });

class DateCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService) {
        super(structuredDataService);
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
    }
    ValueTextChange(event) {
    }
    SetValue() {
    }
}
DateCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DateCellComponent, deps: [{ token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Component });
DateCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: DateCellComponent, selector: "td[date-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">    \r\n</ng-template>\r\n<span #override></span>\r\n", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DateCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[date-cell]', template: "<ng-template [ngIf]=\"!Overridden\">    \r\n</ng-template>\r\n<span #override></span>\r\n" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }]; } });

class PercentageCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService, _elementRef) {
        super(structuredDataService);
        this._elementRef = _elementRef;
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
    }
    ValueTextChange(event) {
        this.Entry.Value = Number.parseFloat(event.target.value);
        this.ChangeEvent.emit(this.Entry);
    }
    SetValue() {
        StructuredDataHelper.TextSetValue(this.Entry, this._elementRef);
    }
}
PercentageCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PercentageCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
PercentageCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: PercentageCellComponent, selector: "td[percentage-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <input type=\"number\" (change)=\"ValueTextChange($event)\" /> %\r\n</ng-template>\r\n<span #override></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PercentageCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[percentage-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <input type=\"number\" (change)=\"ValueTextChange($event)\" /> %\r\n</ng-template>\r\n<span #override></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; } });

class NumberCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService, _elementRef) {
        super(structuredDataService);
        this._elementRef = _elementRef;
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
    }
    ValueTextChange(event) {
        this.Entry.Value = Number.parseFloat(event.target.value);
        this.ChangeEvent.emit(this.Entry);
    }
    SetValue() {
        StructuredDataHelper.TextSetValue(this.Entry, this._elementRef);
    }
}
NumberCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumberCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
NumberCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: NumberCellComponent, selector: "td[number-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <input type=\"number\" (change)=\"ValueTextChange($event)\" />\r\n</ng-template>\r\n<span #override></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumberCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[number-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <input type=\"number\" (change)=\"ValueTextChange($event)\" />\r\n</ng-template>\r\n<span #override></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; } });

class CommodityCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService, _elementRef) {
        super(structuredDataService);
        this._elementRef = _elementRef;
    }
    ValueSelectChange(event) {
        let sel = event.target;
        const entry = this.Entry.Value;
        if (entry) {
            this.Entry.Value.Id = sel.value;
            this.Entry.Value.Value = sel.options[sel.selectedIndex].text;
        }
        else {
            this.Entry.Value = {
                Id: sel.value,
                Value: sel.options[sel.selectedIndex].text
            };
        }
        this.ChangeEvent.emit(this.Entry);
    }
    ValueTextChange(event) {
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(this.Entry);
        });
        return obs;
    }
    SetValue() {
        setTimeout(() => {
            StructuredDataHelper.DropDownSetValue(this.Entry, this._elementRef);
        });
    }
}
CommodityCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CommodityCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CommodityCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CommodityCellComponent, selector: "td[commodity-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of Lookup\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CommodityCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[commodity-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of Lookup\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; } });

class StructuredDataHeaderRowComponent extends StructuredDataBaseComponent {
    constructor() {
        super();
        this.StructuredDataNode = null;
        this.ShowDeleteButton = false;
        this.ShowEditButton = false;
    }
    ngOnInit() {
    }
}
StructuredDataHeaderRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataHeaderRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StructuredDataHeaderRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: StructuredDataHeaderRowComponent, selector: "tr[structured-data-header-row]", inputs: { StructuredDataNode: ["structured-data-node", "StructuredDataNode"], ShowDeleteButton: ["delete-enabled", "ShowDeleteButton"], ShowEditButton: ["edit-enabled", "ShowEditButton"] }, usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"StructuredDataNode\">\r\n    <ng-template [ngIf]=\"ShowEditButton\">\r\n        <th class=\"sd-edit-cell\">&nbsp;</th>\r\n    </ng-template>\r\n    <ng-template ngFor let-childNode [ngForOf]=\"StructuredDataNode.ChildNodes\">\r\n        <th>{{childNode.Name}}</th>\r\n    </ng-template>\r\n    <ng-template [ngIf]=\"ShowDeleteButton\">\r\n        <th class=\"sd-edit-cell\">&nbsp;</th>\r\n    </ng-template>\r\n</ng-template>\r\n", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataHeaderRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tr[structured-data-header-row]', template: "<ng-template [ngIf]=\"StructuredDataNode\">\r\n    <ng-template [ngIf]=\"ShowEditButton\">\r\n        <th class=\"sd-edit-cell\">&nbsp;</th>\r\n    </ng-template>\r\n    <ng-template ngFor let-childNode [ngForOf]=\"StructuredDataNode.ChildNodes\">\r\n        <th>{{childNode.Name}}</th>\r\n    </ng-template>\r\n    <ng-template [ngIf]=\"ShowDeleteButton\">\r\n        <th class=\"sd-edit-cell\">&nbsp;</th>\r\n    </ng-template>\r\n</ng-template>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { StructuredDataNode: [{
                type: Input,
                args: ['structured-data-node']
            }], ShowDeleteButton: [{
                type: Input,
                args: ['delete-enabled']
            }], ShowEditButton: [{
                type: Input,
                args: ['edit-enabled']
            }] } });

class EditCellComponent extends StructuredDataBaseComponent {
    constructor(_structuredDataService) {
        super();
        this._structuredDataService = _structuredDataService;
        this.Overridden = false;
        this._hasSurfacedRef = false;
        this._overrideRefReplay = new ReplaySubject(1);
        this.EntryEdit = new EventEmitter();
    }
    set OverrideRef(viewRef) {
        if (!this._hasSurfacedRef) {
            this._hasSurfacedRef = true;
            this._overrideRefReplay.next(viewRef);
        }
    }
    ;
    GetOverrideRef() {
        return this._overrideRefReplay.asObservable();
    }
    ngAfterContentInit() {
        const override = this._structuredDataService.GetDeleteOverride(this.InstanceId);
        if (override) {
            this.Overridden = true;
            this.GetOverrideRef().subscribe((viewRef) => {
                let fireDelete = new Subject();
                fireDelete.subscribe(() => {
                    this.EntryEdit.emit();
                });
                let deleteOverride = {
                    FireDelete: fireDelete,
                    ViewReference: viewRef
                };
                override.Delete.next(deleteOverride);
            });
        }
        else {
            this.Overridden = false;
        }
    }
    Edit() {
        this.EntryEdit.emit();
    }
}
EditCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: EditCellComponent, deps: [{ token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Component });
EditCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: EditCellComponent, selector: "td[edit-cell]", outputs: { EntryEdit: "structured-data-entry-edit" }, viewQueries: [{ propertyName: "OverrideRef", first: true, predicate: ["overrideRef"], descendants: true, read: ViewContainerRef }], usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <button (click)=\"Edit()\" type=\"button\" class=\"list-btn pi pi-pencil\"></button>\r\n</ng-template>\r\n<span #overrideRef></span>\r\n\r\n", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: EditCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[edit-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <button (click)=\"Edit()\" type=\"button\" class=\"list-btn pi pi-pencil\"></button>\r\n</ng-template>\r\n<span #overrideRef></span>\r\n\r\n" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }]; }, propDecorators: { OverrideRef: [{
                type: ViewChild,
                args: ['overrideRef', { read: ViewContainerRef }]
            }], EntryEdit: [{
                type: Output,
                args: ['structured-data-entry-edit']
            }] } });

class CurrencyCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService, _elementRef) {
        super(structuredDataService);
        this._elementRef = _elementRef;
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
        let sel = event.target;
        const entryValue = this.Entry.Value;
        if (entryValue) {
            this.Entry.Value.UnitId = sel.value;
            this.Entry.Value.Unit = sel.options[sel.selectedIndex].text;
        }
        else {
            this.Entry.Value = {
                Value: null,
                UnitId: sel.value,
                Unit: sel.options[sel.selectedIndex].text,
                UnitDecimalPlaces: 0
            };
        }
        this.ChangeEvent.emit(this.Entry);
    }
    ValueTextChange(event) {
        if (this.Entry.Value) {
            this.Entry.Value.Value = Number.parseFloat(event.target.value);
        }
        else {
            this.Entry.Value = {
                Value: Number.parseFloat(event.target.value),
                UnitId: StructuredDataHelper.nullId,
                Unit: '',
                UnitDecimalPlaces: 0
            };
        }
        this.ChangeEvent.emit(this.Entry);
    }
    SetValue() {
        setTimeout(() => {
            StructuredDataHelper.UnitSetValue(this.Entry, this._elementRef);
        });
    }
}
CurrencyCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CurrencyCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CurrencyCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: CurrencyCellComponent, selector: "td[currency-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <input type=\"number\" (change)=\"ValueTextChange($event)\" />\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of Lookup\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CurrencyCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[currency-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <input type=\"number\" (change)=\"ValueTextChange($event)\" />\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of Lookup\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; } });

class ForeignKeyCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService) {
        super(structuredDataService);
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
    }
    ValueTextChange(event) {
    }
    SetValue() {
    }
}
ForeignKeyCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ForeignKeyCellComponent, deps: [{ token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Component });
ForeignKeyCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: ForeignKeyCellComponent, selector: "td[foreign-key-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">    \r\n</ng-template>\r\n<span #override></span>\r\n", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ForeignKeyCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[foreign-key-cell]', template: "<ng-template [ngIf]=\"!Overridden\">    \r\n</ng-template>\r\n<span #override></span>\r\n" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }]; } });

class OptionListCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService, _elementRef) {
        super(structuredDataService);
        this._elementRef = _elementRef;
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
        let sel = event.target;
        const entry = this.Entry.Value;
        if (entry) {
            this.Entry.Value.Id = sel.value;
            this.Entry.Value.Value = sel.options[sel.selectedIndex].text;
        }
        else {
            this.Entry.Value = {
                Id: sel.value,
                Value: sel.options[sel.selectedIndex].text
            };
        }
        this.ChangeEvent.emit(this.Entry);
    }
    ValueTextChange(event) {
    }
    SetValue() {
        StructuredDataHelper.DropDownSetValue(this.Entry, this._elementRef);
    }
    GetCorrectLookupArray() {
        if (this.Lookup.length > 0)
            return this.Lookup.find((lookupOptionList) => {
                return lookupOptionList.Id === this.Node.ValueOption.OptionListId;
            }).Items;
        else
            return [];
    }
}
OptionListCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: OptionListCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
OptionListCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: OptionListCellComponent, selector: "td[option-list-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of GetCorrectLookupArray()\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: OptionListCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[option-list-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of GetCorrectLookupArray()\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; } });

class TextCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService, _elementRef) {
        super(structuredDataService);
        this._elementRef = _elementRef;
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
    }
    ValueTextChange(event) {
        (this.Entry.Value) = event.target.value;
        this.ChangeEvent.emit(this.Entry);
    }
    SetValue() {
        StructuredDataHelper.TextSetValue(this.Entry, this._elementRef);
    }
}
TextCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TextCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
TextCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: TextCellComponent, selector: "td[text-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n        <input type=\"text\" (change)=\"ValueTextChange($event)\" />\r\n</ng-template>\r\n<span #override></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TextCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[text-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n        <input type=\"text\" (change)=\"ValueTextChange($event)\" />\r\n</ng-template>\r\n<span #override></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; } });

class YesNoCellComponent extends StructuredDataEditCellComponent {
    constructor(structuredDataService, _elementRef) {
        super(structuredDataService);
        this._elementRef = _elementRef;
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
        const sel = event.target;
        this.Entry.Value = sel.value;
        this.ChangeEvent.emit(this.Entry);
    }
    ValueTextChange(event) {
    }
    SetValue() {
        setTimeout(() => {
            StructuredDataHelper.DropDownSetValueYesNo(this.Entry, this._elementRef);
        });
    }
}
YesNoCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: YesNoCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
YesNoCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: YesNoCellComponent, selector: "td[yes-no-cell]", usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of Lookup\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: YesNoCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[yes-no-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <select (change)=\"ValueSelectChange($event)\">\r\n        <option value=\"00000000-0000-0000-0000-000000000000\"></option>\r\n        <option *ngFor=\"let lookup of Lookup\" [value]=\"lookup.Id\">{{lookup.Value}}</option>\r\n    </select>\r\n</ng-template>\r\n<span #override></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; } });

class DeleteCellComponent extends StructuredDataBaseComponent {
    constructor(_structuredDataService) {
        super();
        this._structuredDataService = _structuredDataService;
        this.Overridden = false;
        this._hasSurfacedRef = false;
        this._overrideRefReplay = new ReplaySubject(1);
        this.EntryDelete = new EventEmitter();
    }
    set OverrideRef(viewRef) {
        if (!this._hasSurfacedRef) {
            this._hasSurfacedRef = true;
            this._overrideRefReplay.next(viewRef);
        }
    }
    ;
    GetOverrideRef() {
        return this._overrideRefReplay.asObservable();
    }
    ngAfterContentInit() {
        const override = this._structuredDataService.GetDeleteOverride(this.InstanceId);
        if (override) {
            this.Overridden = true;
            this.GetOverrideRef().subscribe((viewRef) => {
                let fireDelete = new Subject();
                fireDelete.subscribe(() => {
                    this.EntryDelete.emit();
                });
                let deleteOverride = {
                    FireDelete: fireDelete,
                    ViewReference: viewRef
                };
                override.Delete.next(deleteOverride);
            });
        }
        else {
            this.Overridden = false;
        }
    }
    Delete() {
        this.EntryDelete.emit();
    }
}
DeleteCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DeleteCellComponent, deps: [{ token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Component });
DeleteCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: DeleteCellComponent, selector: "td[delete-cell]", outputs: { EntryDelete: "structured-data-entry-delete" }, viewQueries: [{ propertyName: "OverrideRef", first: true, predicate: ["overrideRef"], descendants: true, read: ViewContainerRef }], usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <button (click)=\"Delete()\" type=\"button\" class=\"list-btn pi pi-trash\"></button>\r\n</ng-template>\r\n<span #overrideRef></span>\r\n\r\n", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DeleteCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[delete-cell]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <button (click)=\"Delete()\" type=\"button\" class=\"list-btn pi pi-trash\"></button>\r\n</ng-template>\r\n<span #overrideRef></span>\r\n\r\n" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }]; }, propDecorators: { OverrideRef: [{
                type: ViewChild,
                args: ['overrideRef', { read: ViewContainerRef }]
            }], EntryDelete: [{
                type: Output,
                args: ['structured-data-entry-delete']
            }] } });

class StructuredDataEditRowComponent extends StructuredDataBaseComponent {
    constructor() {
        super();
        this.StructuredDataNode = null;
        this.StructuredDataEntry = null;
        this.ShowDeleteButton = true;
        this.ShowEditButton = true;
        this.isLastRow = false;
        this.EntryChange = new EventEmitter();
        this.EntryDelete = new EventEmitter();
        this.EntryEdit = new EventEmitter();
        this.AddNewRow = new EventEmitter();
    }
    ngOnInit() {
    }
    EntryChanged(entry) {
        this.EntryChange.emit(entry);
    }
    EntryDeleted() {
        this.EntryDelete.emit(this.StructuredDataEntry);
    }
    EntryEdited() {
        this.EntryEdit.emit(this.StructuredDataEntry);
    }
    getCorrespondingEntry(node) {
        if (this.StructuredDataEntry) {
            return this.StructuredDataEntry.ChildEntries.find((entry) => {
                return node.Id === entry.StructuredDataNodeId;
            });
        }
        else {
            return null;
        }
    }
    IsCommodityCell(valueType) {
        return StructuredDataHelper.IsCommodityCell(valueType);
    }
    RaiseAddNewRowEvent() {
        if (this.isLastRow) {
            this.AddNewRow.emit();
        }
    }
    IsCurrencyCell(valueType) {
        return StructuredDataHelper.IsCurrencyCell(valueType);
    }
    IsDateCell(valueType) {
        return StructuredDataHelper.IsDateCell(valueType);
    }
    IsForeignKeyCell(valueType) {
        return StructuredDataHelper.IsForeignKeyCell(valueType);
    }
    IsNumberCell(valueType) {
        return StructuredDataHelper.IsNumberCell(valueType);
    }
    IsOptionListCell(valueType) {
        return StructuredDataHelper.IsOptionListCell(valueType);
    }
    IsPercentageCell(valueType) {
        return StructuredDataHelper.IsPercentageCell(valueType);
    }
    IsUnitValueCell(valueType) {
        return StructuredDataHelper.IsUnitValueCell(valueType);
    }
    IsBooleanCell(valueType) {
        return StructuredDataHelper.IsYesNoCell(valueType);
    }
    IsTextCell(valueType) {
        return StructuredDataHelper.IsTextCell(valueType);
    }
}
StructuredDataEditRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataEditRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StructuredDataEditRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: StructuredDataEditRowComponent, selector: "tr[structured-data-edit-row]", inputs: { StructuredDataNode: ["structured-data-node", "StructuredDataNode"], StructuredDataEntry: ["structured-data-entry", "StructuredDataEntry"], ShowDeleteButton: ["delete-enabled", "ShowDeleteButton"], ShowEditButton: ["edit-enabled", "ShowEditButton"], isLastRow: ["is-last-row", "isLastRow"] }, outputs: { EntryChange: "structured-data-entry-change", EntryDelete: "structured-data-entry-delete", EntryEdit: "structured-data-entry-edit", AddNewRow: "structured-data-entry-add-new-row" }, usesInheritance: true, ngImport: i0, template: "\r\n<td *ngIf=\"ShowEditButton\" edit-cell [instance-id]=\"InstanceId\" (structured-data-entry-edit)=\"EntryEdited()\" (keyup.tab)=\"RaiseAddNewRowEvent()\"></td>\r\n\r\n<ng-template ngFor let-node [ngForOf]=\"StructuredDataNode ? StructuredDataNode.ChildNodes : []\">\r\n  <td commodity-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsCommodityCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td currency-cell class=\"multi-cell\" title=\"{{node.Name}}\" [instance-id]=\"InstanceId\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsCurrencyCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td date-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsDateCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td foreign-key-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsForeignKeyCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td number-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsNumberCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td option-list-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsOptionListCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td percentage-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsPercentageCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td text-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsTextCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td unit-value-cell class=\"multi-cell\" title=\"{{node.Name}}\" [instance-id]=\"InstanceId\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsUnitValueCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td yes-no-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsBooleanCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n</ng-template>\r\n\r\n<td *ngIf=\"ShowDeleteButton\" delete-cell [instance-id]=\"InstanceId\" (structured-data-entry-delete)=\"EntryDeleted()\"></td>\r\n", components: [{ type: EditCellComponent, selector: "td[edit-cell]", outputs: ["structured-data-entry-edit"] }, { type: CommodityCellComponent, selector: "td[commodity-cell]" }, { type: CurrencyCellComponent, selector: "td[currency-cell]" }, { type: DateCellComponent, selector: "td[date-cell]" }, { type: ForeignKeyCellComponent, selector: "td[foreign-key-cell]" }, { type: NumberCellComponent, selector: "td[number-cell]" }, { type: OptionListCellComponent, selector: "td[option-list-cell]" }, { type: PercentageCellComponent, selector: "td[percentage-cell]" }, { type: TextCellComponent, selector: "td[text-cell]" }, { type: UnitValueCellComponent, selector: "td[unit-value-cell]" }, { type: YesNoCellComponent, selector: "td[yes-no-cell]" }, { type: DeleteCellComponent, selector: "td[delete-cell]", outputs: ["structured-data-entry-delete"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataEditRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tr[structured-data-edit-row]', template: "\r\n<td *ngIf=\"ShowEditButton\" edit-cell [instance-id]=\"InstanceId\" (structured-data-entry-edit)=\"EntryEdited()\" (keyup.tab)=\"RaiseAddNewRowEvent()\"></td>\r\n\r\n<ng-template ngFor let-node [ngForOf]=\"StructuredDataNode ? StructuredDataNode.ChildNodes : []\">\r\n  <td commodity-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsCommodityCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td currency-cell class=\"multi-cell\" title=\"{{node.Name}}\" [instance-id]=\"InstanceId\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsCurrencyCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td date-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsDateCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td foreign-key-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsForeignKeyCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td number-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsNumberCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td option-list-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsOptionListCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td percentage-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsPercentageCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td text-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsTextCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td unit-value-cell class=\"multi-cell\" title=\"{{node.Name}}\" [instance-id]=\"InstanceId\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsUnitValueCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td yes-no-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsBooleanCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n</ng-template>\r\n\r\n<td *ngIf=\"ShowDeleteButton\" delete-cell [instance-id]=\"InstanceId\" (structured-data-entry-delete)=\"EntryDeleted()\"></td>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { StructuredDataNode: [{
                type: Input,
                args: ['structured-data-node']
            }], StructuredDataEntry: [{
                type: Input,
                args: ['structured-data-entry']
            }], ShowDeleteButton: [{
                type: Input,
                args: ['delete-enabled']
            }], ShowEditButton: [{
                type: Input,
                args: ['edit-enabled']
            }], isLastRow: [{
                type: Input,
                args: ['is-last-row']
            }], EntryChange: [{
                type: Output,
                args: ['structured-data-entry-change']
            }], EntryDelete: [{
                type: Output,
                args: ['structured-data-entry-delete']
            }], EntryEdit: [{
                type: Output,
                args: ['structured-data-entry-edit']
            }], AddNewRow: [{
                type: Output,
                args: ['structured-data-entry-add-new-row']
            }] } });

class ViewCellComponent extends StructuredDataEditCellComponent {
    constructor(_structuredDataService, _elementRef) {
        super(_structuredDataService);
        this._elementRef = _elementRef;
        this.StructuredDataEntry = null;
    }
    GetFireEditObservable() {
        let obs = new Subject();
        obs.subscribe((entry) => {
            this.Entry = entry;
            this.ChangeEvent.emit(entry);
        });
        return obs;
    }
    ValueSelectChange(event) {
    }
    ValueTextChange(event) {
    }
    SetValue() {
    }
    GetDisplayValue(structuredDataEntry) {
        let mapper = this._structuredDataService.GetMapper(this.InstanceId, structuredDataEntry.ValueType);
        if (mapper.IsHtml) {
            this._elementRef.nativeElement.innerHTML = mapper.Map(structuredDataEntry.Value);
            return '';
        }
        else {
            return mapper.Map(structuredDataEntry.Value);
        }
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        //In LFF, the SD list displayed uses the view-cell for all ValueTypes
        //and overrides the ValueType.Date only. When the entry value changes
        //we need to execute Subject.next (in this.ngOnAfterViewInit()).
        if (this.StructuredDataEntry.ValueType === ValueType.Date) {
            if (changes.Entry.firstChange || changes.Entry.previousValue.Value !== changes.Entry.currentValue.Value) {
                //In LFF, the override creates a new instance of the CalendarWrapper so
                //when the value changes we need to remove the previous instance and create a new
                //one with the updated entry value. We know it's fugly and plan to address it during DH'erer
                if (this._elementRef.nativeElement.children.length === 2) {
                    this._elementRef.nativeElement.children[1].remove();
                }
                this.setupOverride();
            }
        }
    }
}
ViewCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ViewCellComponent, deps: [{ token: StructuredDataLibraryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
ViewCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: ViewCellComponent, selector: "td[view-cell]", inputs: { StructuredDataEntry: ["structured-data-entry", "StructuredDataEntry"] }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<ng-template [ngIf]=\"StructuredDataEntry && !Overridden\">\r\n  {{GetDisplayValue(StructuredDataEntry)}}\r\n</ng-template>\r\n<span #override></span>\r\n", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ViewCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[view-cell]', template: "<ng-template [ngIf]=\"StructuredDataEntry && !Overridden\">\r\n  {{GetDisplayValue(StructuredDataEntry)}}\r\n</ng-template>\r\n<span #override></span>\r\n" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }, { type: i0.ElementRef }]; }, propDecorators: { StructuredDataEntry: [{
                type: Input,
                args: ['structured-data-entry']
            }] } });

class StructuredDataViewRowComponent extends StructuredDataBaseComponent {
    constructor(structuredDataLibraryService) {
        super();
        this.structuredDataLibraryService = structuredDataLibraryService;
        this.EntryDelete = new EventEmitter();
        this.EntryEdit = new EventEmitter();
        this.StructuredDataEntry = null;
        this.StructuredDataNode = null;
        this.ShowDeleteButton = false;
        this.ShowEditButton = false;
    }
    EntryDeleted() {
        this.EntryDelete.emit(this.StructuredDataEntry);
    }
    EntryEdited() {
        this.EntryEdit.emit(this.StructuredDataEntry);
    }
    GetCorrespondingEntry(node) {
        if (!this.StructuredDataNode)
            return null;
        else
            return this.StructuredDataEntry.ChildEntries.find((entry) => {
                return entry.StructuredDataNodeId === node.Id;
            });
    }
    DisplayCell(node) {
        if (this.structuredDataLibraryService.HideLabelsForEmptyValues(this.InstanceId)) {
            return this.EntryContainsValue(node);
        }
        return true;
    }
    EntryContainsValue(node) {
        const entryValue = this.GetCorrespondingEntry(node).Value;
        if (typeof entryValue === 'object' && !Array.isArray(entryValue) && entryValue !== null) {
            return entryValue.Value !== null && entryValue.Value !== "";
        }
        return entryValue !== null && entryValue !== "";
    }
    ngOnInit() {
    }
}
StructuredDataViewRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataViewRowComponent, deps: [{ token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Component });
StructuredDataViewRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: StructuredDataViewRowComponent, selector: "tr[structured-data-view-row]", inputs: { StructuredDataEntry: ["structured-data-entry", "StructuredDataEntry"], StructuredDataNode: ["structured-data-node", "StructuredDataNode"], ShowDeleteButton: ["delete-enabled", "ShowDeleteButton"], ShowEditButton: ["edit-enabled", "ShowEditButton"] }, outputs: { EntryDelete: "structured-data-entry-delete", EntryEdit: "structured-data-entry-edit" }, usesInheritance: true, ngImport: i0, template: "<td *ngIf=\"ShowEditButton\" edit-cell [instance-id]=\"InstanceId\" (structured-data-entry-edit)=\"EntryEdited()\"></td>\r\n\r\n<ng-template [ngIf]=\"StructuredDataEntry\">\r\n  <ng-template ngFor let-node [ngForOf]=\"StructuredDataNode.ChildNodes\">\r\n    <td *ngIf=\"DisplayCell(node)\" [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" [data-node]='node' view-cell [entry]=\"GetCorrespondingEntry(node)\" [structured-data-entry]=\"GetCorrespondingEntry(node)\"></td>\r\n  </ng-template>\r\n</ng-template>\r\n\r\n<td *ngIf=\"ShowDeleteButton\" delete-cell [instance-id]=\"InstanceId\" (structured-data-entry-delete)=\"EntryDeleted()\"></td>\r\n", components: [{ type: EditCellComponent, selector: "td[edit-cell]", outputs: ["structured-data-entry-edit"] }, { type: ViewCellComponent, selector: "td[view-cell]", inputs: ["structured-data-entry"] }, { type: DeleteCellComponent, selector: "td[delete-cell]", outputs: ["structured-data-entry-delete"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataViewRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tr[structured-data-view-row]', template: "<td *ngIf=\"ShowEditButton\" edit-cell [instance-id]=\"InstanceId\" (structured-data-entry-edit)=\"EntryEdited()\"></td>\r\n\r\n<ng-template [ngIf]=\"StructuredDataEntry\">\r\n  <ng-template ngFor let-node [ngForOf]=\"StructuredDataNode.ChildNodes\">\r\n    <td *ngIf=\"DisplayCell(node)\" [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" [data-node]='node' view-cell [entry]=\"GetCorrespondingEntry(node)\" [structured-data-entry]=\"GetCorrespondingEntry(node)\"></td>\r\n  </ng-template>\r\n</ng-template>\r\n\r\n<td *ngIf=\"ShowDeleteButton\" delete-cell [instance-id]=\"InstanceId\" (structured-data-entry-delete)=\"EntryDeleted()\"></td>\r\n" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }]; }, propDecorators: { EntryDelete: [{
                type: Output,
                args: ['structured-data-entry-delete']
            }], EntryEdit: [{
                type: Output,
                args: ['structured-data-entry-edit']
            }], StructuredDataEntry: [{
                type: Input,
                args: ['structured-data-entry']
            }], StructuredDataNode: [{
                type: Input,
                args: ['structured-data-node']
            }], ShowDeleteButton: [{
                type: Input,
                args: ['delete-enabled']
            }], ShowEditButton: [{
                type: Input,
                args: ['edit-enabled']
            }] } });

class AddCellComponent extends StructuredDataBaseComponent {
    constructor(_structuredDataService) {
        super();
        this._structuredDataService = _structuredDataService;
        this.Overridden = true;
        this.hasSurfacedRef = false;
        this._overrideRefReplay = new ReplaySubject(1);
        this.EntryAdd = new EventEmitter();
    }
    set OverrideRef(viewRef) {
        if (!this.hasSurfacedRef) {
            this.hasSurfacedRef = true;
            this._overrideRefReplay.next(viewRef);
        }
    }
    ngOnInit() {
        const override = this._structuredDataService.GetAddOverride(this.InstanceId);
        if (override) {
            setTimeout(() => {
                this.Overridden = true;
            });
            this.GetOverrideRef().subscribe((viewRef) => {
                let fireDelete = new Subject();
                fireDelete.subscribe(() => {
                    this.EntryAdd.emit();
                });
                let deleteOverride = {
                    FireDelete: fireDelete,
                    ViewReference: viewRef
                };
                override.Add.next(deleteOverride);
            });
        }
        else {
            this.Overridden = false;
        }
    }
    GetOverrideRef() {
        return this._overrideRefReplay.asObservable();
    }
    Add() {
        this.EntryAdd.emit();
    }
}
AddCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AddCellComponent, deps: [{ token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Component });
AddCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AddCellComponent, selector: "td[add-button]", outputs: { EntryAdd: "structured-data-entry-add" }, viewQueries: [{ propertyName: "OverrideRef", first: true, predicate: ["overrideRef"], descendants: true, read: ViewContainerRef }], usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <button (click)=\"Add()\" type=\"button\">Add New Row</button>\r\n</ng-template>\r\n<span #overrideRef></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AddCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[add-button]', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <button (click)=\"Add()\" type=\"button\">Add New Row</button>\r\n</ng-template>\r\n<span #overrideRef></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }]; }, propDecorators: { OverrideRef: [{
                type: ViewChild,
                args: ['overrideRef', { read: ViewContainerRef }]
            }], EntryAdd: [{
                type: Output,
                args: ['structured-data-entry-add']
            }] } });

class PaginatorComponent extends StructuredDataBaseComponent {
    constructor(_structuredDataService) {
        super();
        this._structuredDataService = _structuredDataService;
        this.Overridden = true;
        this.PageCount = 0;
        this.Pages = [];
        this.TotalRecords = 0;
        this.PageLimit = 0;
        this.OnPageChange = new EventEmitter();
        this.hasSurfacedRef = false;
        this._overrideRefReplay = new ReplaySubject(1);
    }
    set OverrideRef(viewRef) {
        if (!this.hasSurfacedRef) {
            this.hasSurfacedRef = true;
            this._overrideRefReplay.next(viewRef);
        }
    }
    SetPages(currentPage) {
        // calculate total pages
        let maxPages = 5;
        let totalPages;
        let startPage;
        let endPage;
        this.PageCount, totalPages = Math.ceil(this.TotalRecords / this.PageLimit);
        if (totalPages <= maxPages) {
            // total pages less than max so show all pages
            startPage = 1;
            endPage = totalPages;
        }
        else {
            // total pages more than max so calculate start and end pages
            let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
            let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
            if (currentPage <= maxPagesBeforeCurrentPage) {
                // current page near the start
                startPage = 1;
                endPage = maxPages;
            }
            else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
                // current page near the end
                startPage = totalPages - maxPages + 1;
                endPage = totalPages;
            }
            else {
                // current page somewhere in the middle
                startPage = currentPage - maxPagesBeforeCurrentPage;
                endPage = currentPage + maxPagesAfterCurrentPage;
            }
        }
        // create an array of pages to ng-repeat in the pager control
        this.Pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
    }
    ngOnInit() {
        this.PageCount = Math.ceil(this.TotalRecords / this.PageLimit);
        this.PageChange = {
            First: 1,
            Page: 1,
            Limit: this.PageLimit,
            TotalRecords: this.TotalRecords
        };
        this.SetPages(1);
        const override = this._structuredDataService.GetPaginationOverride(this.InstanceId);
        if (override) {
            setTimeout(() => {
                this.Overridden = true;
            });
            this.GetOverrideRef().subscribe((viewRef) => {
                let pageChange = new Subject();
                pageChange.subscribe((paginatorPageChange) => {
                    this.OnPageChange.emit(paginatorPageChange);
                });
                let structuredDataPaginationOverride = {
                    PageChangeSubject: pageChange,
                    ViewReference: viewRef
                };
                override.OnPageChange.next(structuredDataPaginationOverride);
            });
        }
        else {
            this.Overridden = false;
        }
    }
    GetOverrideRef() {
        return this._overrideRefReplay.asObservable();
    }
    Paginate(page) {
        if ((page <= this.PageCount) && (page >= 1)) {
            this.PageChange.Page = page;
            this.PageChange.TotalRecords = this.TotalRecords;
            this.PageChange.Limit = this.PageLimit;
            this.SetPages(page);
            this.OnPageChange.emit(this.PageChange);
        }
    }
}
PaginatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PaginatorComponent, deps: [{ token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Component });
PaginatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: PaginatorComponent, selector: "sd-paginator", inputs: { TotalRecords: ["total-records", "TotalRecords"], PageLimit: ["limit", "PageLimit"] }, outputs: { OnPageChange: "on-page-change" }, viewQueries: [{ propertyName: "OverrideRef", first: true, predicate: ["overrideRef"], descendants: true, read: ViewContainerRef }], usesInheritance: true, ngImport: i0, template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <button (click)=\"Paginate(1)\">First</button>\r\n    <button (click)=\"Paginate(PageChange.Page - 1)\">Previous</button>\r\n    <ng-template ngFor let-page [ngForOf]=\"Pages\">\r\n        <button (click)=\"Paginate(page)\">{{page}}</button>\r\n    </ng-template>\r\n    <button (click)=\"Paginate(PageChange.Page + 1)\">Next</button>\r\n    <button (click)=\"Paginate(PageCount)\">Last</button>\r\n</ng-template>\r\n<span #overrideRef></span>", directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PaginatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sd-paginator', template: "<ng-template [ngIf]=\"!Overridden\">\r\n    <button (click)=\"Paginate(1)\">First</button>\r\n    <button (click)=\"Paginate(PageChange.Page - 1)\">Previous</button>\r\n    <ng-template ngFor let-page [ngForOf]=\"Pages\">\r\n        <button (click)=\"Paginate(page)\">{{page}}</button>\r\n    </ng-template>\r\n    <button (click)=\"Paginate(PageChange.Page + 1)\">Next</button>\r\n    <button (click)=\"Paginate(PageCount)\">Last</button>\r\n</ng-template>\r\n<span #overrideRef></span>" }]
        }], ctorParameters: function () { return [{ type: StructuredDataLibraryService }]; }, propDecorators: { TotalRecords: [{
                type: Input,
                args: ['total-records']
            }], PageLimit: [{
                type: Input,
                args: ['limit']
            }], OnPageChange: [{
                type: Output,
                args: ['on-page-change']
            }], OverrideRef: [{
                type: ViewChild,
                args: ['overrideRef', { read: ViewContainerRef }]
            }] } });

class StructuredDataTableComponent extends StructuredDataBaseComponent {
    constructor(elementRef, structuredDataService) {
        super();
        this.elementRef = elementRef;
        this.structuredDataService = structuredDataService;
        this.StructuredData = null;
        this.ShowHeaders = true;
        this.ShowAddButton = true;
        this.TotalRecords = 0;
        this.ShowDeleteButton = true;
        this.ShowEditButton = true;
        this.PaginationEnabled = false;
        this.EmptyMessage = 'The list is empty';
        this._editMode = false;
        this.EntryChange = new EventEmitter();
        this.OnPageChange = new EventEmitter();
        this.EntryDelete = new EventEmitter();
        this.EntryEdit = new EventEmitter();
        this.EntryAdd = new EventEmitter();
    }
    EntryDeleted(entry) {
        this.RemoveEntry(entry);
        this.EntryDelete.emit(entry);
    }
    EntryEdited(entry) {
        this.EntryEdit.emit(entry);
    }
    Paginate(pageEvent) {
        this.OnPageChange.emit(pageEvent);
    }
    EntryChanged(entry) {
        this.EntryChange.emit(entry);
    }
    AddNewRow() {
        const blankStructuredDataEntry = StructuredDataHelper.GetNullEntryFromNode(this.StructuredData.Node);
        this.StructuredData.Entries.push(blankStructuredDataEntry);
        this.EntryAdd.emit(blankStructuredDataEntry);
        this.numberOfEntryRows = this.StructuredData.Entries.length;
    }
    isEdit() {
        return this._editMode;
    }
    isView() {
        return !this._editMode;
    }
    RemoveEntry(entry) {
        let spliceIndex = this.StructuredData.Entries.findIndex((removeEntry) => {
            return removeEntry.Id === entry.Id;
        });
        this.StructuredData.Entries.splice(spliceIndex, 1);
        this.numberOfEntryRows = this.StructuredData.Entries.length;
    }
    ngOnInit() {
        this.numberOfEntryRows = this.StructuredData.Entries.length;
    }
    ngOnDestroy() {
        this.structuredDataService.DiscardInstance(this.InstanceId);
    }
}
StructuredDataTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataTableComponent, deps: [{ token: i0.ElementRef }, { token: StructuredDataLibraryService }], target: i0.ɵɵFactoryTarget.Component });
StructuredDataTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: StructuredDataTableComponent, selector: "table[structured-data-table]", inputs: { StructuredData: ["structured-data", "StructuredData"], ShowHeaders: ["show-headers", "ShowHeaders"], ShowAddButton: ["add-enabled", "ShowAddButton"], TotalRecords: ["total-records", "TotalRecords"], ShowDeleteButton: ["delete-enabled", "ShowDeleteButton"], ShowEditButton: ["edit-enabled", "ShowEditButton"], PaginationEnabled: ["pagination-enabled", "PaginationEnabled"], EmptyMessage: ["empty-message", "EmptyMessage"], _editMode: ["is-edit-mode", "_editMode"] }, outputs: { EntryChange: "structured-data-entry-change", OnPageChange: "on-page-change", EntryDelete: "structured-data-entry-delete", EntryEdit: "structured-data-entry-edit", EntryAdd: "structured-data-entry-add" }, usesInheritance: true, ngImport: i0, template: "<thead>\r\n    <ng-template [ngIf]=\"StructuredData && ShowHeaders\">\r\n        <tr [instance-id]=\"InstanceId\" [delete-enabled]=\"ShowDeleteButton\" [edit-enabled]=\"ShowEditButton\" structured-data-header-row\r\n            [structured-data-node]=\"StructuredData.Node\"></tr>\r\n    </ng-template>\r\n</thead>\r\n<tbody>\r\n    <ng-template ngFor let-entry [ngForOf]=\"StructuredData && isEdit() ? StructuredData.Entries : []\" let-index=\"index\">\r\n        <tr [instance-id]=\"InstanceId\" structured-data-edit-row (structured-data-entry-change)=\"EntryChanged($event)\" (structured-data-entry-delete)=\"EntryDeleted($event)\" (structured-data-entry-edit)=\"EntryEdited($event)\"\r\n            (structured-data-entry-add-new-row)=\"AddNewRow()\" [structured-data-node]=\"StructuredData.Node\" [structured-data-entry]=\"entry\" [delete-enabled]=\"ShowDeleteButton\" [edit-enabled]=\"ShowEditButton\" [is-last-row]=\"index + 1 === this.numberOfEntryRows\">\r\n        </tr>\r\n    </ng-template>\r\n    <ng-template ngFor let-entry [ngForOf]=\"StructuredData && isView() ? StructuredData.Entries : []\">\r\n        <tr [instance-id]=\"InstanceId\" structured-data-view-row\r\n            [structured-data-node]=\"StructuredData.Node\"\r\n            [structured-data-entry]=\"entry\"\r\n            [edit-enabled]=\"ShowEditButton\"\r\n            [delete-enabled]=\"ShowDeleteButton\"\r\n            (structured-data-entry-delete)=\"EntryDeleted($event)\"\r\n            (structured-data-entry-edit)=\"EntryEdited($event)\"\r\n        ></tr>\r\n    </ng-template>\r\n\r\n    <tr *ngIf=\"PaginationEnabled && StructuredData?.Entries?.length == 0\">\r\n        <td [innerText]=\"EmptyMessage\" colspan=\"10\"></td>\r\n    </tr>\r\n\r\n    <tr *ngIf=\"ShowAddButton\">\r\n        <td colspan=\"50\" add-button [instance-id]=\"InstanceId\" (structured-data-entry-add)=\"AddNewRow()\" ></td>\r\n    </tr>\r\n\r\n</tbody>\r\n\r\n<ng-template [ngIf]=\"PaginationEnabled && StructuredData?.Entries?.length > 0\">\r\n    <sd-paginator [instance-id]=\"InstanceId\" (on-page-change)=\"Paginate($event)\" [total-records]=\"TotalRecords\" [limit]=\"numberOfEntryRows\"></sd-paginator>\r\n</ng-template>\r\n", components: [{ type: StructuredDataHeaderRowComponent, selector: "tr[structured-data-header-row]", inputs: ["structured-data-node", "delete-enabled", "edit-enabled"] }, { type: StructuredDataEditRowComponent, selector: "tr[structured-data-edit-row]", inputs: ["structured-data-node", "structured-data-entry", "delete-enabled", "edit-enabled", "is-last-row"], outputs: ["structured-data-entry-change", "structured-data-entry-delete", "structured-data-entry-edit", "structured-data-entry-add-new-row"] }, { type: StructuredDataViewRowComponent, selector: "tr[structured-data-view-row]", inputs: ["structured-data-entry", "structured-data-node", "delete-enabled", "edit-enabled"], outputs: ["structured-data-entry-delete", "structured-data-entry-edit"] }, { type: AddCellComponent, selector: "td[add-button]", outputs: ["structured-data-entry-add"] }, { type: PaginatorComponent, selector: "sd-paginator", inputs: ["total-records", "limit"], outputs: ["on-page-change"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'table[structured-data-table]', template: "<thead>\r\n    <ng-template [ngIf]=\"StructuredData && ShowHeaders\">\r\n        <tr [instance-id]=\"InstanceId\" [delete-enabled]=\"ShowDeleteButton\" [edit-enabled]=\"ShowEditButton\" structured-data-header-row\r\n            [structured-data-node]=\"StructuredData.Node\"></tr>\r\n    </ng-template>\r\n</thead>\r\n<tbody>\r\n    <ng-template ngFor let-entry [ngForOf]=\"StructuredData && isEdit() ? StructuredData.Entries : []\" let-index=\"index\">\r\n        <tr [instance-id]=\"InstanceId\" structured-data-edit-row (structured-data-entry-change)=\"EntryChanged($event)\" (structured-data-entry-delete)=\"EntryDeleted($event)\" (structured-data-entry-edit)=\"EntryEdited($event)\"\r\n            (structured-data-entry-add-new-row)=\"AddNewRow()\" [structured-data-node]=\"StructuredData.Node\" [structured-data-entry]=\"entry\" [delete-enabled]=\"ShowDeleteButton\" [edit-enabled]=\"ShowEditButton\" [is-last-row]=\"index + 1 === this.numberOfEntryRows\">\r\n        </tr>\r\n    </ng-template>\r\n    <ng-template ngFor let-entry [ngForOf]=\"StructuredData && isView() ? StructuredData.Entries : []\">\r\n        <tr [instance-id]=\"InstanceId\" structured-data-view-row\r\n            [structured-data-node]=\"StructuredData.Node\"\r\n            [structured-data-entry]=\"entry\"\r\n            [edit-enabled]=\"ShowEditButton\"\r\n            [delete-enabled]=\"ShowDeleteButton\"\r\n            (structured-data-entry-delete)=\"EntryDeleted($event)\"\r\n            (structured-data-entry-edit)=\"EntryEdited($event)\"\r\n        ></tr>\r\n    </ng-template>\r\n\r\n    <tr *ngIf=\"PaginationEnabled && StructuredData?.Entries?.length == 0\">\r\n        <td [innerText]=\"EmptyMessage\" colspan=\"10\"></td>\r\n    </tr>\r\n\r\n    <tr *ngIf=\"ShowAddButton\">\r\n        <td colspan=\"50\" add-button [instance-id]=\"InstanceId\" (structured-data-entry-add)=\"AddNewRow()\" ></td>\r\n    </tr>\r\n\r\n</tbody>\r\n\r\n<ng-template [ngIf]=\"PaginationEnabled && StructuredData?.Entries?.length > 0\">\r\n    <sd-paginator [instance-id]=\"InstanceId\" (on-page-change)=\"Paginate($event)\" [total-records]=\"TotalRecords\" [limit]=\"numberOfEntryRows\"></sd-paginator>\r\n</ng-template>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: StructuredDataLibraryService }]; }, propDecorators: { StructuredData: [{
                type: Input,
                args: ['structured-data']
            }], ShowHeaders: [{
                type: Input,
                args: ['show-headers']
            }], ShowAddButton: [{
                type: Input,
                args: ['add-enabled']
            }], TotalRecords: [{
                type: Input,
                args: ['total-records']
            }], ShowDeleteButton: [{
                type: Input,
                args: ['delete-enabled']
            }], ShowEditButton: [{
                type: Input,
                args: ['edit-enabled']
            }], PaginationEnabled: [{
                type: Input,
                args: ['pagination-enabled']
            }], EmptyMessage: [{
                type: Input,
                args: ['empty-message']
            }], _editMode: [{
                type: Input,
                args: ['is-edit-mode']
            }], EntryChange: [{
                type: Output,
                args: ['structured-data-entry-change']
            }], OnPageChange: [{
                type: Output,
                args: ['on-page-change']
            }], EntryDelete: [{
                type: Output,
                args: ['structured-data-entry-delete']
            }], EntryEdit: [{
                type: Output,
                args: ['structured-data-entry-edit']
            }], EntryAdd: [{
                type: Output,
                args: ['structured-data-entry-add']
            }] } });

class StructuredDataNewRowComponent extends StructuredDataBaseComponent {
    constructor() {
        super();
        this.StructuredDataNode = null;
        this.StructuredDataEntry = null;
        this.RowCreate = new EventEmitter();
    }
    ngOnInit() {
    }
    ngOnAfterViewInit() {
    }
    getCorrespondingEntry(node) {
        if (this.StructuredDataEntry) {
            return this.StructuredDataEntry.ChildEntries.find((entry) => {
                return node.Id === entry.StructuredDataNodeId;
            });
        }
        else {
            return null;
        }
    }
    EntryChanged(stucturedDataEntry) {
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.SetEmptyEntry();
        });
    }
    SetEmptyEntry() {
        this.StructuredDataEntry = StructuredDataHelper.GetNullEntryFromNode(this.StructuredDataNode);
    }
    IsCommodityCell(valueType) {
        return StructuredDataHelper.IsCommodityCell(valueType);
    }
    IsCurrencyCell(valueType) {
        return StructuredDataHelper.IsCurrencyCell(valueType);
    }
    IsDateCell(valueType) {
        return StructuredDataHelper.IsDateCell(valueType);
    }
    IsForeignKeyCell(valueType) {
        return StructuredDataHelper.IsForeignKeyCell(valueType);
    }
    IsNumberCell(valueType) {
        return StructuredDataHelper.IsNumberCell(valueType);
    }
    IsOptionListCell(valueType) {
        return StructuredDataHelper.IsOptionListCell(valueType);
    }
    IsPercentageCell(valueType) {
        return StructuredDataHelper.IsPercentageCell(valueType);
    }
    IsUnitValueCell(valueType) {
        return StructuredDataHelper.IsUnitValueCell(valueType);
    }
    IsBooleanCell(valueType) {
        return StructuredDataHelper.IsYesNoCell(valueType);
    }
    IsTextCell(valueType) {
        return StructuredDataHelper.IsTextCell(valueType);
    }
}
StructuredDataNewRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataNewRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StructuredDataNewRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: StructuredDataNewRowComponent, selector: "tr[structured-data-new-row]", inputs: { StructuredDataNode: ["structured-data-node", "StructuredDataNode"] }, outputs: { RowCreate: "row-create" }, usesInheritance: true, ngImport: i0, template: "<ng-template ngFor let-node [ngForOf]=\"StructuredDataNode && StructuredDataEntry ? StructuredDataNode.ChildNodes : []\">\r\n  <td commodity-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsCommodityCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td currency-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsCurrencyCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td date-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsDateCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td foreign-key-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsForeignKeyCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td number-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsNumberCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td option-list-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsOptionListCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td percentage-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsPercentageCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td text-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsTextCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td unit-value-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsUnitValueCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td yes-no-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsBooleanCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n</ng-template>\r\n\r\n<td>&nbsp;</td>\r\n", components: [{ type: CommodityCellComponent, selector: "td[commodity-cell]" }, { type: CurrencyCellComponent, selector: "td[currency-cell]" }, { type: DateCellComponent, selector: "td[date-cell]" }, { type: ForeignKeyCellComponent, selector: "td[foreign-key-cell]" }, { type: NumberCellComponent, selector: "td[number-cell]" }, { type: OptionListCellComponent, selector: "td[option-list-cell]" }, { type: PercentageCellComponent, selector: "td[percentage-cell]" }, { type: TextCellComponent, selector: "td[text-cell]" }, { type: UnitValueCellComponent, selector: "td[unit-value-cell]" }, { type: YesNoCellComponent, selector: "td[yes-no-cell]" }], directives: [{ type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataNewRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tr[structured-data-new-row]', template: "<ng-template ngFor let-node [ngForOf]=\"StructuredDataNode && StructuredDataEntry ? StructuredDataNode.ChildNodes : []\">\r\n  <td commodity-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsCommodityCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td currency-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsCurrencyCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td date-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsDateCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td foreign-key-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsForeignKeyCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td number-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsNumberCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td option-list-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsOptionListCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td percentage-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsPercentageCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td text-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsTextCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td unit-value-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsUnitValueCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n\r\n  <td yes-no-cell [instance-id]=\"InstanceId\" title=\"{{node.Name}}\" (structured-entry-data-change)=\"EntryChanged($event)\" *ngIf=\"IsBooleanCell(node.ValueOption.ValueType)\" [data-node]='node' [entry]='getCorrespondingEntry(node)'></td>\r\n</ng-template>\r\n\r\n<td>&nbsp;</td>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { StructuredDataNode: [{
                type: Input,
                args: ['structured-data-node']
            }], RowCreate: [{
                type: Output,
                args: ['row-create']
            }] } });

class StructuredDataModule {
}
StructuredDataModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StructuredDataModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataModule, declarations: [UnitValueCellComponent,
        DateCellComponent,
        PercentageCellComponent,
        NumberCellComponent,
        CommodityCellComponent,
        OptionListCellComponent,
        StructuredDataTableComponent,
        StructuredDataHeaderRowComponent,
        ViewCellComponent,
        YesNoCellComponent,
        StructuredDataEditRowComponent,
        StructuredDataViewRowComponent,
        ForeignKeyCellComponent,
        TextCellComponent,
        CurrencyCellComponent,
        DeleteCellComponent,
        EditCellComponent,
        StructuredDataNewRowComponent,
        AddCellComponent,
        PaginatorComponent], imports: [CommonModule], exports: [UnitValueCellComponent,
        DateCellComponent,
        PercentageCellComponent,
        NumberCellComponent,
        CommodityCellComponent,
        YesNoCellComponent,
        OptionListCellComponent,
        StructuredDataTableComponent,
        StructuredDataHeaderRowComponent,
        ViewCellComponent,
        StructuredDataEditRowComponent,
        StructuredDataViewRowComponent,
        ForeignKeyCellComponent,
        TextCellComponent,
        CurrencyCellComponent] });
StructuredDataModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: StructuredDataModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UnitValueCellComponent,
                        DateCellComponent,
                        PercentageCellComponent,
                        NumberCellComponent,
                        CommodityCellComponent,
                        OptionListCellComponent,
                        StructuredDataTableComponent,
                        StructuredDataHeaderRowComponent,
                        ViewCellComponent,
                        YesNoCellComponent,
                        StructuredDataEditRowComponent,
                        StructuredDataViewRowComponent,
                        ForeignKeyCellComponent,
                        TextCellComponent,
                        CurrencyCellComponent,
                        DeleteCellComponent,
                        EditCellComponent,
                        StructuredDataNewRowComponent,
                        AddCellComponent,
                        PaginatorComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        UnitValueCellComponent,
                        DateCellComponent,
                        PercentageCellComponent,
                        NumberCellComponent,
                        CommodityCellComponent,
                        YesNoCellComponent,
                        OptionListCellComponent,
                        StructuredDataTableComponent,
                        StructuredDataHeaderRowComponent,
                        ViewCellComponent,
                        StructuredDataEditRowComponent,
                        StructuredDataViewRowComponent,
                        ForeignKeyCellComponent,
                        TextCellComponent,
                        CurrencyCellComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of structured-data
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CommodityCellComponent, CurrencyCellComponent, DateCellComponent, ForeignKeyCellComponent, NumberCellComponent, OptionListCellComponent, PercentageCellComponent, StructuredDataEditRowComponent, StructuredDataHeaderRowComponent, StructuredDataLibraryService, StructuredDataModule, StructuredDataTableComponent, StructuredDataViewRowComponent, TextCellComponent, UnitValueCellComponent, ValueType, ViewCellComponent, YesNo, YesNoCellComponent };
